import { Typography, makeStyles } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

type Props = {
  brand: string | undefined;
  title: string;
};

const useStyles = makeStyles(() => ({
  divider: {
    marginBottom: "24px",
    marginTop: "12px",
    height: "2px",
  },
  dividerBsm: {
    background: "#F9812A",
  },
  dividerAa: {
    background: "#FFCC00",
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: "24px",
    paddingBottom: "16px",
  },
  titleBsm: {
    fontFamily: "Poppins !important",
    fontWeight: 500,
  },
  titleAa: {
    fontFamily: "New Transport AA !important",
    fontWeight: 700,
  },
}));

const TitleSection: React.FC<Props> = ({ brand, title }) => {
  const classes = useStyles();
  return (
    <>
      <Typography
        variant="h1"
        className={clsx({
          [classes.titleBsm]: brand === "BSM",
          [classes.titleAa]: brand === "AADS",
          [classes.sectionTitle]: true,
        })}
      >
        {title}
      </Typography>
    </>
  );
};

export default TitleSection;
